import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const progressBarClass = `.${manifest.componentJsClass}`;
	const progressBarSelector = document.querySelector(progressBarClass);
	const postContentSelector = document.querySelector('.main-content');

	if (!progressBarSelector) {
		return;
	}

	const { ProgressBar } = await import('./progress-bar');

	const progressBar = new ProgressBar({
		progressBarSelector,
		postContentSelector,
	});

	progressBar.init();
});
